export var IncomeCategory;
(function (IncomeCategory) {
    IncomeCategory["SALARY"] = "SALARY";
    IncomeCategory["BONUS"] = "BONUS";
    IncomeCategory["FREELANCE"] = "FREELANCE";
    IncomeCategory["BUSINESS"] = "BUSINESS";
    IncomeCategory["INVESTMENT"] = "INVESTMENT";
    IncomeCategory["RENTAL"] = "RENTAL";
    IncomeCategory["OTHER"] = "OTHER";
})(IncomeCategory || (IncomeCategory = {}));
//# sourceMappingURL=income-category.enum.js.map